/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import axios from 'axios';
import routes from '../../router/rails-routes';

const state = {
  max: 3,
  products: [],
  showCompare: false,
  properties: [],
  options: [],
  highlightDifferences: false,
};

const mutations = {
  ADD_PRODUCT(state, product) {
    if (!state.products.find((p) => p.id === product.id)) {
      state.products.push(product);
    }
  },

  SET_PRODUCTS(state, products) {
    state.products = products;
  },

  DELETE_PRODUCT(state, product) {
    state.products = state.products.filter((p) => p.id !== product.id);
  },

  UPDATE_PRODUCT(state, payload) {
    state.products = state.products.map((p) => {
      const prod = p;
      if (prod.id === payload.id) {
        prod.description = payload.description;
        prod.synonyms = payload.synonyms;
        prod.file_msds = payload.file_msds;
        prod.properties = payload.properties;
        prod.options = payload.options;
        prod.variants = payload.variants;
      }
      return prod;
    });
  },

  DELETE_ALL_PRODUCTS(state) {
    state.products = [];
  },

  SHOW_COMPARE_VIEW(state) {
    state.showCompare = true;
  },

  HIDE_COMPARE_VIEW(state) {
    state.showCompare = false;
  },

  UPDATE_PROPERTIES(state, payload) {
    state.properties = payload.sort((a, b) => a.name > b.name);
  },

  UPDATE_OPTIONS(state, payload) {
    state.options = payload;
  },

  TOGGLE_DIFFERENCES(state) {
    state.highlightDifferences = !state.highlightDifferences;
  },
};

const actions = {
  addProduct({ commit, state }, product) {
    if (state.products.length < state.max) {
      commit('ADD_PRODUCT', product);
    }
  },

  deleteProduct({ commit }, product) {
    commit('DELETE_PRODUCT', product);
  },

  getProduct({ commit }, product) {
    return axios({
      method: 'get',
      url: `${routes.productShowUrl}/${product.id}`,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      commit('UPDATE_PRODUCT', response.data);
    });
  },

  getProducts({ commit }, productIds) {
    return Promise.all(productIds.map((productId) => axios({
      method: 'get',
      url: `${routes.productShowUrl}/${productId}`,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => response.data))).then((products) => commit('SET_PRODUCTS', products));
  },

  getOptions({ commit }) {
    axios({
      method: 'get',
      url: '/api/option_types',
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      commit('UPDATE_OPTIONS', response.data);
    });
  },

  getProperties({ commit }) {
    axios({
      method: 'get',
      url: '/api/properties',
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      commit('UPDATE_PROPERTIES', response.data.properties);
    });
  },
};

const getters = {
  max: (state) => state.max,
  products: (state) => state.products,
  showCompare: (state) => state.showCompare,
  properties: (state) => state.properties,
  options: (state) => state.options,
  highlightDifferences: (state) => state.highlightDifferences,
};

const compareModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default compareModule;
